import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { getNumber, getRandomColor } from '../../utils/avatar.utils';

@Component({
  selector: 'lib-avatar-ring',
  templateUrl: './avatar-ring.component.html',
  styleUrl: './avatar-ring.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarRingComponent implements OnInit {
  @Input({ required: true }) colors!: string[];
  @Input({ required: true }) name!: string;
  @Input() inputSize = 40;

  private COLORS = 5;

  SIZE = 90;
  cellColors: string[] = [];

  ngOnInit() {
    this.cellColors = this.generateColors(this.colors, this.name);
  }

  generateColors(colors: Array<string>, name: string): Array<string> {
    const numFromName = getNumber(name);
    const range = colors && colors.length;
    const colorsShuffle = Array.from({ length: this.COLORS }, (_, i) =>
      getRandomColor(numFromName + (i + 1), colors, range)
    );
    const iconColors = [];
    iconColors[0] = colorsShuffle[0];
    iconColors[1] = colorsShuffle[1];
    iconColors[2] = colorsShuffle[1];
    iconColors[3] = colorsShuffle[2];
    iconColors[4] = colorsShuffle[2];
    iconColors[5] = colorsShuffle[3];
    iconColors[6] = colorsShuffle[3];
    iconColors[7] = colorsShuffle[0];
    iconColors[8] = colorsShuffle[4];

    return iconColors;
  }
}
